import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BehaviorSubject } from 'rxjs'
import { WeeklyScheduleEditComponent } from '../weekly-schedule-edit/weekly-schedule-edit.component'
import { WorkSchedule } from '../work-schedule'

import { AsyncPipe } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { MatIconButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import {
  ElderIntervalInputComponent,
  ElderIntervalPickerBindingDirective,
  ElderIntervalPickerToggleComponent,
  ElderPaneActionsComponent,
  ElderPaneContentComponent,
  ElderPaneHeaderComponent,
  ElderPaneSubtitleComponent,
  ElderPaneTitleComponent,
  ElderSinglePaneWrapperComponent,
} from '@elderbyte/ngx-starter'

@Component({
  selector: 'app-work-schedule-edit',
  templateUrl: './work-schedule-edit.component.html',
  styleUrls: ['./work-schedule-edit.component.scss'],
  imports: [
    ElderSinglePaneWrapperComponent,
    ElderPaneHeaderComponent,
    ElderPaneTitleComponent,
    ElderPaneSubtitleComponent,
    ElderPaneActionsComponent,
    ElderPaneContentComponent,
    AsyncPipe,
    FormsModule,
    MatIconButton,
    MatIcon,
    MatSuffix,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    ElderIntervalInputComponent,
    WeeklyScheduleEditComponent,
    ElderTranslatePipe,
    ElderIntervalPickerBindingDirective,
    ElderIntervalPickerToggleComponent,
  ],
})
export class WorkScheduleEditComponent<T extends WorkSchedule> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  public readonly schedule$ = new BehaviorSubject<T>(null)

  @Output()
  public scheduleChanged: EventEmitter<T> = new EventEmitter<T>()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set schedule(schedule: T) {
    this.schedule$.next(schedule)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public save(event: Event): void {
    this.scheduleChanged.emit(this.schedule$.getValue())
  }
}
